/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import axios from "axios";
import { connectorApi, connectorDetailsApi } from "../../constants/Presets";

// function that makes the api request and returns a Promise for response
export function FetchAnalytics(payload) {
  const url = payload
    ? `${connectorDetailsApi}?company_id=${payload}`
    : connectorDetailsApi;
  return axios.get(url);
}
export function FetchAAnalytic(id) {
  return axios.get(`${connectorApi}/${id}`);
}
